export default "__VITE_ASSET__D8KCh0CS__"